var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.PRODUCT_FRAGMENT = void 0;
const graphql_tag_1 = __importDefault(require("graphql-tag"));
const imageFragment_1 = require("./imageFragment");
const mediaFragment_1 = require("./mediaFragment");
const metafieldFragment_1 = require("./metafieldFragment");
const priceFragment_1 = require("./priceFragment");
const priceRangeFragment_1 = require("./priceRangeFragment");
const variantFragment_1 = require("./variantFragment");
exports.PRODUCT_FRAGMENT = (0, graphql_tag_1.default) `
  fragment ProductFragment on Product {
    id
    handle
    title
    description
    descriptionHtml
    productType
    vendor
    tags
    availableForSale
    publishedAt
    updatedAt
    createdAt
    options {
      id
      name
      values
    }
    priceRange {
      ...PriceRangeFragment
    }
    presentmentPriceRanges(first: 100) {
      edges {
        node {
          ...PresentmentPriceRangeFragment
        }
      }
    }
    images(first: $firstImages) {
      edges {
        node {
          ...ImageFragment
        }
      }
    }
    media(first: $firstMedia) {
      edges {
        node {
          mediaContentType
          ...MediaImageFragment
          ...MediaVideoFragment
          ...MediaExternalVideoFragment
          ...MediaModel3dFragment
        }
      }
    }
    metafields(first: $firstMetafields) {
      edges {
        node {
          ...MetafieldFragment
        }
      }
    }
    variants(first: $firstVariants, after: $afterVariants) {
      edges {
        node {
          ...VariantFragment
        }
      }
    }
    collections(first: $firstCollections) {
      edges {
        node {
          id
          title
          handle
          description
          image {
            ...ImageFragment
          }
        }
      }
    }
  }
  ${imageFragment_1.IMAGE_FRAGMENT}
  ${mediaFragment_1.MEDIA_IMAGE_FRAGMENT}
  ${mediaFragment_1.MEDIA_VIDEO_FRAGMENT}
  ${mediaFragment_1.MEDIA_EXTERNAL_VIDEO_FRAGMENT}
  ${mediaFragment_1.MEDIA_MODEL_FRAGMENT}
  ${metafieldFragment_1.METAFIELD_FRAGMENT}
  ${priceRangeFragment_1.PRICE_RANGE_FRAGMENT}
  ${priceFragment_1.PRESENTMENT_PRICE_FRAGMENT}
  ${priceRangeFragment_1.PRESENTMENT_PRICE_RANGE_FRAGMENT}
  ${variantFragment_1.VARIANT_FRAGMENT}
`;
//# sourceMappingURL=productFragment.js.map